import * as React from "react";
import { useState, useEffect, useContext, useMemo } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import SystemAlert from "../../components/common/SystemAlert";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrnDetails from "../../components/grid/ViewDataGridGrnDetails";
import ViewGrnSupplier from "../../components/grn/ViewGrnSupplier";
import ViewGrnPo from "../../components/grn/ViewGrnPo";
import ViewGrnAttachments from "../../components/grn/ViewGrnAttachments";
import ViewGrnBillInfo from "../../components/grn/ViewGrnBillInfo";
import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import GrnStatusHistory from "../../components/grn/GrnStatusHistory";
// @ts-ignore
import GrnPdf from "../../features/documents/GrnPdf";
// @ts-ignore
import RejectionNotePdf from "../../features/documents/RejectionNotePdf";
import ViewDataReturnsummaryDeatils from "../grid/ViewDataReturnsummaryDeatils";
// @ts-ignore
import ReturnNotePdf from "../../features/documents/ReturnNotePdf";
// @ts-ignore
import DebitNotePdf from "../../features/documents/DebitNotePdf";
import ViewReturnBillinfo from "./ViewReturnBillinfo";
import ViewGrnReturnInfo from "./ViewGrnReturnInfo";
import { AnyForNow, GrnData, GrnItem } from "../../features/grn/types";
import { useGrnDetailLayout } from "../../features/grn/hooks/useGrnDetailLayout";
import ViewReturnGrnPo from "./ViewReturnGrnPo";
import ViewDataReturnsummaryDetails from "../grid/ViewDataReturnsummaryDeatils";
interface ViewReturnDetailBodyProps {
  statusCode?: string | number;
  grnItems?: GrnItem[] | AnyForNow;
  selectedSupplier?: AnyForNow;
  grnDetailsForm?: AnyForNow;
  attachments?: AnyForNow;
  grnHeader?: AnyForNow;
  grncode?: string;
  trackingDetails?: AnyForNow;
  grnstatuscode?: string | number;
  grnDocuments?: AnyForNow;
  returnedProducts?: AnyForNow;
  grnReturns?: AnyForNow;
  grnPaySummery?: AnyForNow[];
  grnPayTax?: AnyForNow[];
  grnReturnMaster?: AnyForNow[];
  billingSummary?: AnyForNow;
  totalGross?: number | string;
  taxValues?: AnyForNow;
  grnTaxTypes?: AnyForNow[];
  grnCompany?: AnyForNow;
  grnData?: GrnData | AnyForNow;
  grnreject?: AnyForNow;
  Returncal?: AnyForNow;
  trsts?: AnyForNow;
  grnreturncode?: AnyForNow; returneddate?: AnyForNow;
}

const ViewReturnDetailBody: React.FC<ViewReturnDetailBodyProps> = ({
  statusCode,
  grnItems,
  selectedSupplier,
  grnDetailsForm,
  attachments,
  grnHeader,
  grncode,
  trackingDetails,
  grnstatuscode,
  grnDocuments,
  returnedProducts,
  grnReturns,
  grnPaySummery,
  grnPayTax,
  grnReturnMaster,
  billingSummary,
  totalGross,
  taxValues,
  grnTaxTypes,
  grnCompany,
  grnData,
  grnreject,
  Returncal,
  grnreturncode,returneddate
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const { setPageData } = useContext(PageDataContext);
  const {
    rightSidebarRef,
    rightSidebarOpen,
    toggleRightSidebar,
    docType,
    openPdf,
    setOpenPdf,
    handleOpenPdf,
  } = useGrnDetailLayout();
  console.log("returnedProducts", returnedProducts);
  console.log("Returncalresponse",Returncal)
  console.log("grnData", grnData);
  console.log("grnPaySummery", grnPaySummery);
  
  // Sidebar toggling handled by hook
  useEffect(() => {
    setPageData({
      title: "Return Summary",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const [alert, setAlert] = useState<{
    open: boolean;
    type: string;
    message: string;
  }>({
    open: false,
    type: "success",
    message: "",
  });

  const handleAlertClose = () => {
    setAlert({ ...alert, open: false });
  };

  const filteredReturnedProducts = useMemo(
    () =>
      Array.isArray(returnedProducts)
        ? returnedProducts.filter((item) => Number(item?.returnedqty) > 0)
        : [],
    [returnedProducts]
  );

  console.log("returnedProducts....", filteredReturnedProducts);

  return (
    <>
      <Box
        ref={rightSidebarRef}
        sx={{
          position: "fixed",
          top: 64,
          right: rightSidebarOpen ? 0 : "-320px",
          width: { xs: "80vw", sm: 320 },
          height: "100vh",
          bgcolor: "background.paper",
          boxShadow: 3,
          p: 1,
          zIndex: 1,
          transition: "right 0.3s ease-in-out",
          pointerEvents: "auto", // sidebar accepts pointer events
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          scrollbarWidth: "none", // Hide scrollbar in Firefox
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar in WebKit browsers
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",

            alignItems: "center",
            my: 1,
          }}
        >
          <Typography variant="h6">GRN Tracking</Typography>
          <IconButton
            onClick={toggleRightSidebar}
            size="small"
            aria-label="close sidebar"
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </Box>
        <Divider />
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            scrollbarWidth: "none", // Hide scrollbar in Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar in WebKit browsers
            },
          }}
        >
          <GrnStatusHistory
            trackingDetails={trackingDetails}
            grncode={grncode}
          />
        </Box>
      </Box>
      <Box sx={styles.grn_supplier_container}>
        <Grid container spacing={2}>
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={styles.title_text}>
              {grncode ? `GRN ID: ${grncode}` : "Submit GRN"}
            </Typography>

            <Tooltip title="View History">
              <IconButton
                onClick={toggleRightSidebar}
                disabled={statusCode === 3}
              >
                <ViewSidebarOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Divider />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
              }}
            >
              <ViewGrnSupplier
                onOpenSidebar={toggleRightSidebar}
                selectedSupplier={selectedSupplier}
                statusCode={statusCode}
                grnHeader={grnHeader}
                grncode={grncode}
                grnstatuscode={grnstatuscode}
                hidePurchaseReceive={true}
              />
            </Box>
          </Grid>

          <Grid
            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
            sx={{
              width: "50%",
              display: "flex",
              justifyItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
                display: "flex",
                justifyItems: "flex-end",
              }}
            >
              

                     <ViewReturnGrnPo
                              grnDetailsForm={grnDetailsForm}
                           grnHeader={grnHeader}
                              grncode={grncode}
                                  grnreturncode={grnreturncode}
                              returneddate={returneddate}  />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box>
        {/* <ViewDataReturnDeatils
          grnItems={grnItems}
          grnDocuments={grnDocuments}
          returnedProducts={filteredReturnedProducts}
          grnData={grnData}
          grnReturns={grnReturns}
          grnreject={grnreject}
          Returncal = {Returncal}
        /> */}
          <ViewDataReturnsummaryDetails
          grnItems={grnItems}
          grnDocuments={grnDocuments}
            grnHeader={grnHeader}
          returnedProducts={filteredReturnedProducts}
          grnData={grnData}
          grnReturns={grnReturns}
          grnreject={grnreject}
          Returncal = {Returncal}
        />
      </Box>

      {/* Attachenments and price */}
{/* 
      <Box pt={2} sx={styles.grn_search_container}>
        <Grid container spacing={6}>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
      
          </Grid> 
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Typography sx={styles.grn_sub_title_text} gutterBottom>
            Financial Information
            </Typography>
            <Divider />
            <ViewGrnReturnInfo
              grnPaySummery={grnPaySummery}
              grnPayTax={grnPayTax}
             billingSummary={billingSummary}
              // grnData={grnData}
              totalGross={totalGross}
              taxValues={taxValues}
              grnTaxTypes={grnTaxTypes}
                 grnItems={grnItems}
                  returnedProducts={filteredReturnedProducts}
                  Returncal = {Returncal}
              grnReturnMaster={grnReturnMaster}
              // grnReturns={grnReturns || returnedProducts}
              grnReturns={
                Array.isArray(grnReturns) && grnReturns.length
                  ? grnReturns
                  : filteredReturnedProducts
              }
            />
          </Grid>

         <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Divider />
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ ...styles.btn_primary }}
              onClick={() => handleOpenPdf("Debit Note")}
            >
              View Debit Note
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ ...styles.btn_primary }}
              onClick={() => handleOpenPdf("Return Note")}
            >
              View Return Note
            </Button>
          </Grid> 
        </Grid>
      </Box>
      <Divider />

      <Dialog
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          {docType} Preview
          <IconButton
            aria-label="close"
            onClick={() => setOpenPdf(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {docType === "Return Note" ? (
            <ReturnNotePdf
              grnHeader={grnHeader}
              grnItems={grnItems}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
               returnedProducts={filteredReturnedProducts}
                Returncal = {Returncal}
              grnReturnMaster={grnReturnMaster}
              // grnReturns={grnReturns || returnedProducts}
              grnReturns={
                Array.isArray(grnReturns) && grnReturns.length
                  ? grnReturns
                  : filteredReturnedProducts
              }
              grnData={grnData}
              grnCompany={grnCompany}
            />
          ) : (
            <DebitNotePdf
              grnHeader={grnHeader}
              grnItems={grnItems}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
               returnedProducts={filteredReturnedProducts}
                Returncal = {Returncal}
              // grnReturns={grnReturns || returnedProducts}
              grnReturns={
                Array.isArray(grnReturns) && grnReturns.length
                  ? grnReturns
                  : filteredReturnedProducts
              }
              grnData={grnData}
              grnCompany={grnCompany}
            />
          )}
        </DialogContent>
      </Dialog> */}

      <SystemAlert
        open={alert.open}
        type={alert.type}
        message={alert.message}
        onClose={handleAlertClose}
      />
    </>
  );
};

export default ViewReturnDetailBody;
